import registerServiceWorker from './registerServiceWorker';
export default function registerDomainServiceWorker(options) {
  return registerServiceWorker('/service-worker.js', options);
}